<div class="eva-3-message -info-secondary -flexible">
    <div class="message-image-container"></div>
    <div class="message-info-text">
        <div class="message-header">
            <h4 class="eva-3-h4 -eva-3-tc-gray-0 -eva-3-hide-small">{{ 'reasons-to-buy-banner.travelWithEverythingResolved.long' | translate }}</h4>
            <h5 class="eva-3-h5 -eva-3-tc-gray-0 -eva-3-hide-medium-up">{{ 'reasons-to-buy-banner.travelWithEverythingResolved' | translate }}</h5>
        </div>
        <div class="message-body">
            <div class="items-conteinter">
                <div class="item" [ngClass]="isMobile ? '-eva-3-pl-lg -eva-3-pr-lg -eva-3-pt-xsm' : '-eva-3-p-md'">
                    <i class="item-icon eva-3-icon-checkmark -eva-3-mr-sm"></i>
                    <div class="item-content">
                        <div [ngClass]="{'-eva-3-mb-sm': !isMobile, 'eva-3-h6': isDesktop, 'eva-3-p -eva-3-bold': !isDesktop}" class="title">{{ 'reasons-to-buy-banner.productRecommendedForDestination' | translate }}</div>
                        <div class="description eva-3-p">{{ firstColumnText }}</div>
                    </div>
                </div>
                <div class="item" [ngClass]="isMobile ? '-eva-3-pl-lg -eva-3-pr-lg -eva-3-pt-sm' : '-eva-3-p-md'">
                    <i class="item-icon eva-3-icon-checkmark -eva-3-mr-sm"></i>
                    <div class="item-content">
                        <div [ngClass]="{'-eva-3-mb-sm': !isMobile, 'eva-3-h6': isDesktop, 'eva-3-p -eva-3-bold': !isDesktop}" class="title">{{ 'reasons-to-buy-banner.tranquilityAndSecurity' | translate }}</div>
                        <div class="description eva-3-p">{{ 'reasons-to-buy-banner.professionalDrivers.safetyCleanliness' | translate }}</div>
                    </div>
                </div>
                <div class="item" [ngClass]="isMobile ? '-eva-3-pl-lg -eva-3-pr-lg -eva-3-pt-sm' : '-eva-3-p-md'">
                    <i class="item-icon eva-3-icon-checkmark -eva-3-mr-sm"></i>
                    <div class="item-content">
                        <div [ngClass]="{'-eva-3-mb-sm': !isMobile, 'eva-3-h6': isDesktop, 'eva-3-p -eva-3-bold': !isDesktop}" class="title">{{ 'reasons-to-buy-banner.enjoyYourArrival' | translate }}</div>
                        <div class="description eva-3-p">{{ 'reasons-to-buy-banner.transferStaff.willGuideYou' | translate }}</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>